import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

interface RowButtonProps {
  icon?: IconDefinition;
  iconBgColor?: string;
  iconColor?: string;
  imageUrl?: string;
  title: string;
  description: string;
  onClick?: () => void;
}

export const RowButton: React.FC<RowButtonProps> = ({
  icon,
  iconBgColor,
  iconColor,
  imageUrl,
  title,
  description,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center justify-between py-4 px-2 hover:bg-gray-100 rounded-xl transition-all duration-200 active:scale-95"
    >
      <div className="flex items-center gap-4">
        <div
          className={`w-7 h-7 ${iconBgColor || "bg-gray-100"} rounded flex items-center justify-center overflow-hidden`}
        >
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={title}
              className="w-full h-full object-cover"
            />
          ) : icon ? (
            <FontAwesomeIcon icon={icon} className={`${iconColor} w-5 h-5`} />
          ) : null}
        </div>
        <div className="text-left">
          <h4 className="font-semibold text-black text-sm">{title}</h4>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
      </div>
      <FontAwesomeIcon
        icon={faChevronRight}
        className="text-gray-400 w-4 h-4"
      />
    </button>
  );
};
